// extracted by mini-css-extract-plugin
export default {"headerInput":"FormSection_headerInput__OXmQx","label":"FormSection_label__q-xZI","input":"FormSection_input__vJTGH","inputs":"FormSection_inputs__b+U7c"};